export default __webpack_public_path__ + "static/media/banner3.17c16889.jpg";